// https://github.com/react-dnd/react-dnd/issues/3655#issuecomment-2578808024
import { useCallback } from 'react';

export const useDnDRef = (drag: (element: HTMLDivElement) => void) => {
  return useCallback(
    (element: HTMLDivElement | null) => {
      if (element) {
        drag(element);
      }
    },
    [drag],
  );
};
